import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=1fd201a9&scoped=true"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=1fd201a9&prod&lang=css"
import style1 from "../Styles/cover.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../Styles/common.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "../Styles/iconfont/iconfont.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./MainFrame.vue?vue&type=style&index=4&id=1fd201a9&prod&lang=css"
import style5 from "./MainFrame.vue?vue&type=style&index=5&id=1fd201a9&prod&scoped=true&lang=css"
import style6 from "./MainFrame.vue?vue&type=style&index=6&id=1fd201a9&prod&scoped=true&lang=css"
import style7 from "./MainFrame.vue?vue&type=style&index=7&id=1fd201a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd201a9",
  null
  
)

export default component.exports